import React from 'react';
import { Box, Text } from '@goodrx/matisse';

export const PageHeading = ({ title, subtitle, ...props }: any) => {
  return (
    <Box mb={{ _: 4, md: 5 }} {...props}>
      <Text as="h1" m={0} fontSize={22} data-testid={title}>
        {title}
      </Text>

      {subtitle && (
        <Text as="p" color="greyDarkest" mt="8px" mb={0}>
          {subtitle}
        </Text>
      )}
    </Box>
  );
};
